// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetRecipientViewRequest {
    static getAttributeTypeMap() {
        return GetRecipientViewRequest.attributeTypeMap;
    }
}
GetRecipientViewRequest.discriminator = undefined;
GetRecipientViewRequest.additionalProperties = false;
GetRecipientViewRequest.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "envelopeId",
        "baseName": "envelopeId",
        "type": "string"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "returnUrl",
        "baseName": "returnUrl",
        "type": "string"
    },
];
//# sourceMappingURL=getRecipientViewRequest.js.map